<template>
  <router-link :to="link">
    <card
      class="card-stats"
      :show-footer-line="true">
      <div class="row">
        <div
          class="col-5"
          v-if="$slots.icon || icon">
          <div
            class="info-icon text-center"
            :class="`icon-${type}`">
            <slot name="icon"> <i :class="icon" /> </slot>
          </div>
        </div>
        <div
          class="col-7"
          v-if="$slots.content || title || subTitle">
          <div class="numbers">
            <slot>
              <p
                v-if="subTitle"
                class="card-category">{{ subTitle }}</p>
              <h3
                v-if="title"
                class="card-title">{{ title }}</h3>
            </slot>
          </div>
        </div>
      </div>
      <div
        class="stats"
        slot="footer"
        v-if="$slots.footer">
        <slot name="footer" />
      </div>
    </card>
  </router-link>
</template>
<script>
import Card from './Card.vue';

export default {
  name: 'StatsCard',
  components: {
    Card,
  },
  props: {
    type: {
      type: String,
      default: 'primary',
    },
    icon: String,
    title: String,
    subTitle: String,
    link: {
      type: String,
      default: '',
    },
  },
};
</script>
<style></style>
